import React, { Fragment, useState, useEffect } from 'react';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import { formatNumber } from '../../../../Utils/Money';
import DataReactTableReceiptsPatient from './DataReactTableReceiptsPatient';
import Spinner from 'react-bootstrap/Spinner';
import reciptPdf from './../../../../Admissions/SearchAdmissions/components/ReciptPdf';
import IconButton from '@material-ui/core/IconButton';
import { Modal, FormControl, FormGroup, FormControlLabel, Checkbox, withStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const PatientsReceipts = ({ id_patient }) => {
    const [patient, setPatient] = useState(null);
    const [receipts, setReceipts] = useState(null);
    const [load, setLoad] = useState(false);
    const [showPDFReceipt, setShowPDFReceipt] = useState(false);
    const profile = JSON.parse(sessionStorage.getItem('clinica'));

    useEffect(() => {
        const loadSearchPatient = async () => {
            let dataSend = {
                num_documento: parseInt(id_patient)
            }

            await fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    if (data.existe) {
                        setPatient(data.contenido[0]);
                        loadReceipstFromPatient(data.contenido[0].id_historia);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }

        const loadReceipstFromPatient = async (id_historia) => {
            setLoad(true);
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/consultar-por-paciente-particular?id_historia=' + id_historia, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    if (typeof data !== '[]') {
                        setReceipts(data);
                    }
                    setLoad(false);
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }

        loadSearchPatient();
    }, [])

    const loadReceiptsByAdmission = async (id_admision) => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/consultar-recibos-por-admision?id_admision=' + id_admision, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            }).then(response => {
                return response.json();
            }).then(res => {
                resolve(res);
            }).catch((error) => {
                console.error('Error:', error);
                resolve([]);
            });
        })
    }

    const showInLetterReceiptsState = (state_receipt, canceledReceipt) => {
        let receipts_state = '';
        if (state_receipt === 1 && canceledReceipt !== true) {
            receipts_state = 'ACTIVO'
        } else if (state_receipt === 2 && canceledReceipt !== true) {
            receipts_state = 'FACTURADO'
        } else {
            receipts_state = 'ANULADO'
        }
        return receipts_state;
    }

    const calculateSubtotalReceipt = (copago, total) => {
        try {
            let subtotal = parseInt(copago) + parseInt(total);
            return subtotal;
        }
        catch (err) {
            console.log(err);
        }
    }

    const loadBilling = async (id_admision) => {
        return new Promise((resolve, reject) => {
            var dataBilling = { id_admision: id_admision };
            console.log(dataBilling);
            fetch(process.env.REACT_APP_PUBLIC_URL + 'reciboscaja/admisionpaga', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataBilling)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    //setBilling(data.contenido[0])
                    resolve(data.contenido[0]);
                }).catch((e) => {
                    console.log(e);
                    reject(e);
                });
        })
    }

    const loadPlan = async (billing) => {
        return new Promise((resolve, reject) => {
            var dataClose = { id_plan: billing?.id_plan };
            fetch(process.env.REACT_APP_PUBLIC_URL + 'plan/consultar_plan', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataClose)
            }).then(response => {
                return response.json();
            }).then(data => {
                //loadDataProfile(billing, data.contenido[0], dataAdmision);
                resolve(data.contenido[0]);
            }).catch((e) => {
                console.log(e);
                reject(e);
            });
        })
    }

    const printReceiptData = async (receipt) => {
        let openInsideWindow = true;
        let billing = await loadBilling(receipt?.id_admision);
        let plan = await loadPlan(billing);
        let receiptsByAdmission = await loadReceiptsByAdmission(receipt?.id_admision);
        setShowPDFReceipt(true);
        reciptPdf(billing, plan, profile, receiptsByAdmission, openInsideWindow);
    }

    const reactTableDataReceipts = {
        tableHeaderData: [{
            Header: 'ID',
            accessor: 'id_recibo',
            //disableGlobalFilter: true,
        },
        {
            Header: 'RECIBO NRO.',
            accessor: 'num_recibo',
            Cell: row => (
                <div>
                    {
                        row.value != null && row.value ?
                        <label style={{ cursor: 'pointer', color: '#0084CF', textDecoration: 'underline' }} onClick={() => printReceiptData(row.row.original)}>
                            {row.value}
                        </label>
                        : "N/a"
                    }
                </div>
            )
        },
        {
            Header: 'ESTADO',
            accessor: 'estado', /* 1. PENDIENTE, 2. FACTURADO 3.RECHAZADO O CANCELADO */
            Cell: row => (
                <label>{showInLetterReceiptsState(row.cell.row.original.estado, row.cell.row.original.recibo_cancelado)}</label>
            )
        },
        {
            Header: 'FORMA DE PAGO',
            accessor: 'forma_pago',
        },
        {
            Header: 'SUBTOTAL',
            Cell: row => (
                <label>${formatNumber(calculateSubtotalReceipt(row.cell.row.original.total, row.cell.row.original.valor_tercero))}</label>
            )
        },
        {
            Header: "ABONO",
            accessor: 'total',
            Cell: row => (
                <label>${formatNumber(parseInt(row.value))}</label>
            )
        },
        {
            Header: "Total",
            accessor: 'valor_tercero',
            Cell: row => (
                <label>${formatNumber(parseInt(row.value))}</label>
            )
        },
        ],
        tableRowsData: receipts
    };

    const LoadInfo = () => {
        return (<DataReactTableReceiptsPatient
            reactTableData={reactTableDataReceipts}
        />)
    }

    return (
        <Fragment>
            <Col md={12} lg={12} xl={12} xs={12}>
                <Card>
                    <CardBody style={{ padding: 0 }}>
                        <Row>
                            <div className='clinic-history-info'>
                                <div>
                                    <h4><b>RECIBOS</b></h4>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <Col>
                                {
                                    load ?
                                        <div className="text-center">
                                            <Spinner animation="border" style={{ color: '#4ce1b6', marginTop: '2em' }} />
                                        </div>
                                        : receipts ?
                                            <LoadInfo />
                                            :
                                            <div className="info-empty-profile">
                                                <h5>No se ha generado aún ningun Recibo</h5>
                                            </div>

                                }
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
            {showPDFReceipt ?
                <Modal
                    open={showPDFReceipt}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '90%', margin: 10 }}>
                        <IconButton style={{ float: 'right' }} onClick={() => {
                            setShowPDFReceipt(false);
                        }}>
                            <CloseIcon />
                        </IconButton>
                        <div className='container-pdfs-modal'>
                            <iframe className='iframe-pdfs' id="pdfV" >
                            </iframe>
                        </div>
                    </div>
                </Modal>
                : null}
        </Fragment>
    )
}

export default PatientsReceipts